"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var ToolboxItem = function ToolboxItem(_ref) {
  var active = _ref.active,
      classes = _ref.classes,
      className = _ref.className,
      icon = _ref.icon,
      label = _ref.label,
      type = _ref.type,
      handleComponentClick = _ref.handleComponentClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return handleComponentClick(type);
    },
    className: (0, _classnames["default"])(classes.root, active && classes.active, className)
  }, icon ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.icon
  }, icon) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.label
  }, label));
};

var _default = (0, _withStyles["default"])(function (theme) {
  return {
    root: {
      flexShrink: "0",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      color: "black",
      border: "1px solid ".concat(theme.colors.gray200),
      borderRadius: "4px",
      userSelect: "none",
      padding: "12px 16px",
      "&:hover": {
        backgroundColor: theme.colors["gray100"]
      }
    },
    active: {
      backgroundColor: theme.colors["gray200"],
      "&:hover": {
        backgroundColor: theme.colors["gray200"]
      }
    },
    icon: {
      display: "flex",
      color: "#fff",
      background: "#BDBDBD",
      borderRadius: "4px",
      marginRight: "12px"
    },
    label: {
      fontSize: "16px",
      lineHeight: "1.4",
      fontWeight: "600",
      color: "#424242"
    }
  };
})(ToolboxItem);

exports["default"] = _default;